export function downloader(resp) {
  const file = new Blob([resp], { type: "application/zip" });

  const fileURL = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = "docs" + ".zip";
  link.click();
}
